var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bullet",style:({ 'padding-left': (_vm.paddingLeft || 0) + 'px', 'padding-right': (_vm.paddingRight || 0) + 'px' })},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }